import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";
import { Search, RefreshCw, Plus } from "lucide-react";

type SearchFiltersProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchField: "email" | "name";
  page: number;
  totalPages: number;
  isLoading: boolean;
  onRefresh: () => void;
  onOpenCreateDialog: () => void;
};

export const SearchFilters = ({
  searchValue,
  onSearchChange,
  searchField,
  page,
  totalPages,
  isLoading,
  onRefresh,
  onOpenCreateDialog,
}: SearchFiltersProps) => {
  const hasSearch = searchValue.trim().length > 0;

  return (
    <Card className="border border-border/60 bg-white/80 shadow-sm backdrop-blur">
      <CardHeader className="border-b border-border/60 p-5">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg">Search & filters</CardTitle>
            <Badge variant="outline" className="text-xs">
              Page {page} of {totalPages}
            </Badge>
          </div>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search by name or email"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="h-10 rounded-full pl-9"
            />
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
            <span>Searching by {searchField}</span>
            {hasSearch && (
              <Badge variant="outline" className="text-xs">
                {searchValue}
              </Badge>
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 p-5">
        <div className="space-y-2 text-sm text-muted-foreground">
          <p className="font-medium text-foreground">Quick actions</p>
          <div className="grid gap-2">
            <Button
              variant="outline"
              onClick={onRefresh}
              disabled={isLoading}
              className="justify-start gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Refresh directory
            </Button>
            <Button
              variant="outline"
              onClick={onOpenCreateDialog}
              className="justify-start gap-2"
            >
              <Plus className="h-4 w-4" />
              Add new user
            </Button>
          </div>
        </div>
        <div className="rounded-xl border border-border/60 bg-muted/40 p-4 text-xs text-muted-foreground">
          <p className="font-medium text-foreground">Audit hints</p>
          <ul className="mt-2 list-disc space-y-1 pl-4">
            <li>Review elevated roles each week.</li>
            <li>Remove inactive accounts before audits.</li>
            <li>Reset passwords after role changes.</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};
